<script lang="ts">
    import { Router, Route, Link, useLocation} from 'svelte-navigator';
    import { navigate } from 'svelte-navigator';
    import { jwt } from './store.js';
    import { onMount } from 'svelte';
    import RoutesApp from './RoutesApp.svelte';

    onMount(async () => {
            if (($jwt === null || $jwt === undefined || $jwt != '')
            && (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined || localStorage.getItem('token') === ''))
            {
                navigate('/login');
            }
        });
</script>  

<Router>
    <RoutesApp />
</Router>